import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { getAuditLogs } from '../api/audit-logs-admin.api'
import type { AuditLogFilters } from '../types/audit-log'

export function useAuditLogs(filters: AuditLogFilters) {
  return useQuery({
    queryKey: ['admin', 'audit-logs', filters],
    queryFn: () => getAuditLogs(filters),
    placeholderData: keepPreviousData,
  })
}
